export default {
    slug: 'payroll',
    ability: 'payroll',
    reports: () => ({
        title: i18n.t('Payroll'),
        items: [
            {
                route: 'payroll-report-summary',
                icon: 'chart-bar',
                title: i18n.t('Payroll Summary'),
                description: i18n.t('Employee pay totals for a period')
            },
            {
                route: 'payroll-report-remittances',
                icon: 'bank',
                title: i18n.t('Remittances'),
                description: i18n.t('Government deduction remittance totals')
            },
            {
                route: 'payroll-report-tax-slips',
                icon: 'file-document',
                title: i18n.t('T4 / RL-1'),
                description: i18n.t('Year-end tax slip data')
            },
            {
                route: 'payroll-report-employee-earnings',
                icon: 'account-cash',
                title: i18n.t('Employee Earnings'),
                description: i18n.t('Individual employee pay history')
            }
        ]
    }),
    routes: [
        {
            path: 'payroll/employees',
            name: 'employee-list',
            component: () => import('@modules/Payroll/Resources/js/pages/List.vue'),
            children: [
                {
                    path: ':id(\\d+)',
                    name: 'employee-preview',
                    component: () => import('@modules/Payroll/Resources/js/pages/Preview.vue'),
                    redirect: { name: 'employee-overview' },
                    props: true,
                    children: [
                        {
                            path: '/organization/:org/payroll/employees/:id(\\d+)',
                            name: 'employee-overview',
                            component: () => import('@modules/Payroll/Resources/js/pages/preview/Overview.vue'),
                            props: true
                        },
                        {
                            path: 'absences',
                            name: 'employee-absences',
                            component: () => import('@modules/Payroll/Resources/js/pages/preview/Absences.vue'),
                            props: true
                        },
                        {
                            path: 'time-entries',
                            name: 'employee-time-entries',
                            component: () => import('@modules/Payroll/Resources/js/pages/preview/TimeEntries.vue'),
                            props: true
                        },
                        {
                            path: 'time-bank',
                            name: 'employee-timebank',
                            component: () => import('@modules/Payroll/Resources/js/pages/preview/TimeBank.vue'),
                            props: true
                        },
                        // The polymorphic tabs every record gets: they read the
                        // preview's entity type, so nothing here is payroll-specific.
                        {
                            path: 'activities',
                            name: 'employee-activities',
                            component: () => import('@/components/base/tabs/TabActivities.vue'),
                            props: true
                        },
                        {
                            path: 'comments',
                            name: 'employee-comments',
                            component: () => import('@/components/base/tabs/TabComments.vue'),
                            props: true
                        },
                        {
                            path: 'documents',
                            name: 'employee-documents',
                            component: () => import('@/components/base/tabs/TabDocuments.vue'),
                            props: true
                        },
                        {
                            path: 'document-requests',
                            name: 'employee-document-requests',
                            component: () => import('@/components/base/tabs/TabDocumentRequests.vue'),
                            props: true
                        },
                        {
                            path: 'contracts',
                            name: 'employee-contracts',
                            component: () => import('@/components/base/tabs/TabContracts.vue'),
                            props: true
                        },
                        {
                            path: 'logs',
                            name: 'employee-logs',
                            component: () => import('@/components/base/tabs/TabLogs.vue'),
                            props: true
                        }
                    ]
                }
            ]
        },
        {
            path: 'payroll/pay-runs',
            name: 'payroll-pay-runs',
            component: () => import('@modules/Payroll/Resources/js/pages/payruns/List.vue')
        },
        {
            path: 'payroll/pay-runs/:id(\\d+)',
            name: 'payroll-pay-run-detail',
            component: () => import('@modules/Payroll/Resources/js/pages/payruns/Detail.vue'),
            props: true
        },
        {
            path: 'payroll/hours',
            name: 'payroll-hours-review',
            component: () => import('@modules/Payroll/Resources/js/pages/HoursReview.vue')
        },
        {
            path: 'payroll/settings',
            name: 'payroll-settings',
            component: () => import('@modules/Payroll/Resources/js/pages/settings/Index.vue')
        },
        {
            path: 'payroll/settings/deduction-templates',
            name: 'payroll-deduction-templates',
            component: () => import('@modules/Payroll/Resources/js/pages/settings/DeductionTemplates.vue')
        },
        {
            path: 'payroll/settings/tax-tables',
            name: 'payroll-tax-tables',
            component: () => import('@modules/Payroll/Resources/js/pages/settings/TaxTables.vue')
        },
        {
            path: 'payroll/settings/gl-accounts',
            name: 'payroll-gl-accounts',
            component: () => import('@modules/Payroll/Resources/js/pages/settings/GlAccounts.vue')
        },
        {
            path: 'payroll/settings/working-hours',
            name: 'payroll-working-hours',
            component: () => import('@modules/Payroll/Resources/js/pages/settings/WorkingHours.vue')
        },
        {
            path: 'payroll/settings/holiday-calendars',
            name: 'payroll-holiday-calendars',
            component: () => import('@modules/Payroll/Resources/js/pages/settings/HolidayCalendars.vue')
        },
        {
            path: 'payroll/settings/holidays',
            name: 'payroll-holidays',
            component: () => import('@modules/Payroll/Resources/js/pages/settings/Holidays.vue')
        },
        {
            path: 'payroll/reports/summary',
            name: 'payroll-report-summary',
            component: () => import('@modules/Payroll/Resources/js/pages/reports/Summary.vue')
        },
        {
            path: 'payroll/reports/remittances',
            name: 'payroll-report-remittances',
            component: () => import('@modules/Payroll/Resources/js/pages/reports/Remittances.vue')
        },
        {
            path: 'payroll/reports/tax-slips',
            name: 'payroll-report-tax-slips',
            component: () => import('@modules/Payroll/Resources/js/pages/reports/TaxSlips.vue')
        },
        {
            path: 'payroll/reports/employee-earnings',
            name: 'payroll-report-employee-earnings',
            component: () => import('@modules/Payroll/Resources/js/pages/reports/EmployeeEarnings.vue')
        }
    ],
    nav: () => ({
        section: 'hr',
        items: [
            { title: i18n.t('Employees'), icon: 'account-multiple-outline', to: { name: 'employee-list' } },
            {
                // Vouching for a team's hours and paying them are different jobs:
                // the server has always gated this on `timesheets`, and the menu
                // said nothing, so it inherited payroll's own ability and offered
                // a screen the endpoint then refused.
                title: i18n.t('Hours approval'),
                icon: 'clipboard-check-outline',
                to: { name: 'payroll-hours-review' },
                ability: 'timesheets'
            },
            { title: i18n.t('Pay Runs'), icon: 'cash-multiple', to: { name: 'payroll-pay-runs' } },
            { title: i18n.t('Payroll Settings'), icon: 'cog-outline', to: { name: 'payroll-settings' } }
        ]
    })
};
